// user
export const FETCH_USERS_INIT = "user@FETCH_USERS_INIT"
export const FETCH_USERS_SUCCEDED = "user@FETCH_USERS_SUCCEDED"
export const FETCH_USERS_FAILED = "user@FETCH_USERS_FAILED"

export const CLEAR_USER = "user@CLEAR_USER"

export const CREATE_USER_INIT = "user@CREATE_USER_INIT"
export const CREATE_USER_SUCCEDED = "user@CREATE_USER_SUCCEDED"
export const CREATE_USER_FAILED = "user@CREATE_USER_FAILED"

export const REGENRATE_USER_PASSWORD_INIT = "user@REGENRATE_USER_PASSWORD_INIT"
export const REGENRATE_USER_PASSWORD_SUCCEDED = "user@REGENRATE_USER_PASSWORD_SUCCEDED"
export const REGENRATE_USER_PASSWORD_FAILED = "user@REGENRATE_USER_PASSWORD_FAILED"

export const FETCH_USER_INIT = "user@FETCH_USER_INIT"
export const FETCH_USER_SUCCEDED = "user@FETCH_USER_SUCCEDED"
export const FETCH_USER_FAILED = "user@FETCH_USER_FAILED"

export const EDIT_USER_INIT = "user@EDIT_USER_INIT"
export const EDIT_USER_SUCCEDED = "user@EDIT_USER_SUCCEDED"
export const EDIT_USER_FAILED = "user@EDIT_USER_FAILED"

export const DISABLE_USER_INIT = "user@DISABLE_USER_INIT"
export const DISABLE_USER_SUCCEDED = "user@DISABLE_USER_SUCCEDED"
export const DISABLE_USER_FAILED = "user@DISABLE_USER_FAILED"

export const ENABLE_USER_INIT = "user@ENABLE_USER_INIT"
export const ENABLE_USER_SUCCEDED = "user@ENABLE_USER_SUCCEDED"
export const ENABLE_USER_FAILED = "user@ENABLE_USER_FAILED"

export const DISABLE_USERS_INIT = "user@DISABLE_USERS_INIT"
export const DISABLE_USERS_SUCCEDED = "user@DISABLE_USERS_SUCCEDED"
export const DISABLE_USERS_FAILED = "user@DISABLE_USERS_FAILED"

export const ENABLE_USERS_INIT = "user@ENABLE_USERS_INIT"
export const ENABLE_USERS_SUCCEDED = "user@ENABLE_USERS_SUCCEDED"
export const ENABLE_USERS_FAILED = "user@ENABLE_USERS_FAILED"

export const DELETE_USER_INIT = "user@DELETE_USER_INIT"
export const DELETE_USER_SUCCEDED = "user@DELETE_USER_SUCCEDED"
export const DELETE_USER_FAILED = "user@DELETE_USER_FAILED"

export const SOFT_DELETE_USER_INIT = "user@SOFT_DELETE_USER_INIT"
export const SOFT_DELETE_USER_SUCCEDED = "user@SOFT_DELETE_USER_SUCCEDED"
export const SOFT_DELETE_USER_FAILED = "user@SOFT_DELETE_USER_FAILED"

export const DELETE_USERS_INIT = "user@DELETE_USERS_INIT"
export const DELETE_USERS_SUCCEDED = "user@DELETE_USERS_SUCCEDED"
export const DELETE_USERS_FAILED = "user@DELETE_USERS_FAILED"

export const SOFT_DELETE_USERS_INIT = "user@SOFT_DELETE_USERS_INIT"
export const SOFT_DELETE_USERS_SUCCEDED = "user@SOFT_DELETE_USERS_SUCCEDED"
export const SOFT_DELETE_USERS_FAILED = "user@SOFT_DELETE_USERS_FAILED"
